<template>
    <el-container class="doc-editor">
        <el-header class="doc-editor__header">
            <!-- 顶部操作栏：文档信息 + 标题 + 主操作 -->
            <div class="doc-toolbar">
                <div class="doc-toolbar__info">
                    <span class="doc-toolbar__icon">
                        <el-icon>
                            <Document />
                        </el-icon>
                    </span>
                    <span class="doc-toolbar__meta">
                        <span class="doc-toolbar__title">{{ collected.name || '未命名文集' }}</span>
                        <span class="doc-toolbar__subtitle">{{ parentDocPath || '直属文集' }}</span>
                    </span>
                </div>
                <div class="doc-toolbar__field">
                    <el-input v-model="title" class="doc-title-input" placeholder="请输入文档标题" clearable></el-input>
                </div>
                <div class="doc-toolbar__actions">
                    <el-button v-if="docId" class="toolbar-btn toolbar-btn--ghost" @click="save">
                        <el-icon>
                            <Select />
                        </el-icon><span>保存</span>
                    </el-button>
                    <el-button v-if="operationStatus" class="toolbar-btn toolbar-btn--primary" @click="saveAndClose">
                        <el-icon>
                            <CircleCheck />
                        </el-icon><span>保存并关闭</span>
                    </el-button>
                    <el-button class="toolbar-btn toolbar-btn--ghost toolbar-btn--danger" @click="close">
                        <el-icon>
                            <SwitchButton />
                        </el-icon><span>关闭</span>
                    </el-button>
                </div>
            </div>
            <!-- 次级操作栏：文档工具 + 锁定状态 -->
            <div class="doc-toolbar doc-toolbar--tools">
                <div class="doc-toolbar__actions">
                    <el-button class="toolbar-btn toolbar-btn--ghost" @click="openTempletDialog()">
                        <el-icon>
                            <Notebook />
                        </el-icon><span>使用模板</span>
                    </el-button>
                    <el-button class="toolbar-btn toolbar-btn--ghost">
                        <el-icon>
                            <Document />
                        </el-icon><span>使用文档</span>
                    </el-button>
                    <el-button class="toolbar-btn toolbar-btn--ghost" @click="openIlinkDialog()">
                        <el-icon>
                            <Link />
                        </el-icon><span>引用文档</span>
                    </el-button>
                    <span class="doc-toolbar__split"></span>
                    <el-button class="toolbar-btn toolbar-btn--ghost" @click="openUploadFileDialog('')">
                        <el-icon>
                            <FolderOpened />
                        </el-icon><span>插入文件</span>
                    </el-button>
                    <el-button class="toolbar-btn toolbar-btn--ghost" @click="openUploadFileDialog('video')">
                        <el-icon>
                            <VideoPlay />
                        </el-icon><span>插入视频</span>
                    </el-button>
                </div>
                <div class="doc-toolbar__status">
                    <el-tag v-if="lockUser && lockUser.realName" type="warning" size="small" effect="plain">当前由：{{ lockUser.realName }} 编辑锁定</el-tag>
                </div>
            </div>
        </el-header>
        <el-main>
            <v-md-editor ref="editor" v-model="content" height="100%" :include-level="[1, 2, 3, 4]" :disabled-menus="[]" left-toolbar="undo redo clear | h bold italic strikethrough quote | ul ol table hr | link image code | ilink" :before-preview-change="beforePreviewChange" @upload-image="handleUploadImage" @change="textChange" :toolbar="toolbar"></v-md-editor>
        </el-main>

        <!-- 引用文档弹出框 -->
        <el-dialog v-model="ilinkDialog.show" title="引用文档" width="50%" center>
            <el-container>
                <el-header>
                    <el-input v-model="this.ilinkDialog.searchText" placeholder="搜索一下" class="input-with-select" @keydown="searchIlinkEnter" clearable>
                        <template #prepend>
                            <el-select v-model="this.ilinkDialog.searchMode" placeholder="Select" style="width: 110px">
                                <el-option label="全文" value="1"></el-option>
                                <el-option label="关键字" value="2"></el-option>
                            </el-select>
                        </template>
                        <template #append>
                            <el-button @click="searchIlink()">
                                <el-icon><Search /></el-icon>
                            </el-button>
                        </template>
                    </el-input>
                </el-header>
                <el-main style="margin-left: 30px; margin-right: 30px">
                    <div style="height: 360px">
                        <el-collapse accordion>
                            <el-collapse-item v-for="colItem in this.ilinkDialog.collectedList" :key="colItem" :title="colItem.name" :name="colItem.id">
                                <div v-for="docItem in colItem.docLites" :key="docItem" style="border-bottom: 1px dashed #ccc; padding: 2px">
                                    <div class="import-item" style="cursor: pointer" @click="addIlinkDoc(docItem.title, colItem.id, docItem.id)">
                                        <span>　{{ docItem.title }}　</span>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-main>
            </el-container>
            <template #footer>
                <span class="dialog-footer">
                    <el-affix position="bottom" :offset="20">
                        <el-button type="primary" size="mini" @click="ilinkDialog.show = false" style="width: 200px">关闭</el-button>
                    </el-affix>
                </span>
            </template>
        </el-dialog>

        <!-- 模板文档弹出框 -->
        <el-dialog v-model="templetDialog.show" title="模板文档" width="50%" center>
            <el-container>
                <el-header>
                    <el-input v-model="this.templetDialog.searchText" placeholder="搜索一下" class="input-with-select" @keydown="searchTempletEnter" clearable>
                        <template #prepend>
                            <el-select v-model="this.templetDialog.searchMode" placeholder="Select" style="width: 110px">
                                <el-option label="全文" value="1"></el-option>
                                <el-option label="关键字" value="2"></el-option>
                            </el-select>
                        </template>
                        <template #append>
                            <el-button @click="searchTemplet()">
                                <el-icon><Search /></el-icon>
                            </el-button>
                        </template>
                    </el-input>
                </el-header>
                <el-main style="margin-left: 30px; margin-right: 30px">
                    <div style="height: 360px">
                        <el-collapse accordion>
                            <el-collapse-item v-for="colItem in this.templetDialog.collectedList" :key="colItem" :title="colItem.name" :name="colItem.id">
                                <div v-for="docItem in colItem.docLites" :key="docItem" style="border-bottom: 1px dashed #ccc; padding: 2px">
                                    <div class="import-item" style="cursor: pointer" @click="addTempletDoc(docItem.title, colItem.id, docItem.id)">
                                        <span>　{{ docItem.title }}　</span>
                                    </div>
                                </div>
                            </el-collapse-item>
                        </el-collapse>
                    </div>
                </el-main>
            </el-container>
            <template #footer>
                <span class="dialog-footer">
                    <el-affix position="bottom" :offset="20">
                        <el-button type="primary" size="mini" @click="templetDialog.show = false" style="width: 200px">关闭</el-button>
                    </el-affix>
                </span>
            </template>
        </el-dialog>

        <el-dialog :title="上传文件" v-model="uploadSet.dialogVisible">
            <doc-file-upload v-bind:uploadDataParams="uploadSet.uploadDataParams" :callback="uploadCallback" ref="docFileUpload"></doc-file-upload>
            <template #footer>
                <span class="dialog-footer">
                    <el-button type="primary" @click="uploadSet.dialogVisible = false">完 成</el-button>
                </span>
            </template>
        </el-dialog>
        <!-- 文档标签 -->
        <!-- <el-footer>
            <el-row>
                <el-tag :key="tag" v-for="tag in dynamicTags" closable :disable-transitions="false" @close="handleClose(tag)">
                    {{tag}}
                </el-tag>
                <el-input class="input-new-tag" v-if="inputVisible" v-model="inputValue" ref="saveTagInput" size="small" @keyup.enter="handleInputConfirm" @blur="handleInputConfirm">
                </el-input>
                <el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
            </el-row>
        </el-footer> -->
    </el-container>
</template>

<script>
import { ElMessage, ElMessageBox } from 'element-plus';
import DocFileUpload from './DocFileUpload';
import request from '../../../utils/request.js';
import { config } from '@/utils/config';
import { mdFormat } from '../../../utils/mdtools';
import { uiRefresh } from '../../../utils/uimsg';
import _, { includes } from 'lodash';

export default {
    name: 'editor',
    data() {
        this.toolbar = {
            ilink: {
                title: 'mermaid示例',
                icon: 'v-md-icon-tip',
                action(editor) {
                    editor.insert(function (selected) {
                        const prefix = '```mermaid\n';
                        const suffix = '```';
                        const placeholder = 'sequenceDiagram\n' + '    participant Alice\n' + '    participant Bob\n' + '    Alice->>John: Hello John, how are you?\n' + '    loop Healthcheck\n' + '        John->>John: Fight against hypochondria\n' + '    end\n' + '    Note right of John: Rational thoughts <br/>prevail!\n' + '    John-->>Alice: Great!\n' + '    John->>Bob: How about you?\n' + '    Bob-->>John: Jolly good!\n';
                        const content = selected || placeholder;

                        return {
                            text: `${prefix}${content}${suffix}`,
                            selected: content
                        };
                    });
                }
            }
        };
        return {
            heartbeatTimer: '',
            ilinkDialog: {
                show: false,
                collectedList: [],
                searchMode: '',
                searchText: ''
            },
            templetDialog: {
                show: false,
                collectedList: [],
                searchMode: '',
                searchText: ''
            },
            dynamicTags: ['标签一', '标签二', '标签三'],
            inputVisible: false,
            inputValue: '',
            collected: {},
            activeName: 'public',
            content: '',
            contentHtml: '',
            title: '',
            docId: '',
            parentDocId: '',
            parentDocPath: '',
            mode: '',
            operationStatus: true,
            loadStatus: 'create',
            createMode: '',
            uploadSet: {
                dialogVisible: false,
                uploadDataParams: {
                    bucketName: '.hidoc'
                }
            },
            lockUser: {}
        };
    },
    mounted() {
        document.title = 'Hidoc-文档编辑器';
        // 标记当前页面为加载状态
        this.loadStatus = 'mounted';
        // 默认开启目录导航
        this.$refs.editor.toggleToc();

        // ========== ========== 关闭标签页时提示 ========== ==========
        window.isCloseHint = true;
        window.addEventListener('beforeunload', function (e) {
            if (window.isCloseHint) {
                var confirmationMessage = '您所作的更改可能未保存，确认离开吗？';
                (e || window.event).returnValue = confirmationMessage; // 兼容 Gecko + IE
                return confirmationMessage; // 兼容 Gecko + Webkit, Safari, Chrome
            }
        });
        // ========== ========== ========== ==========

        console.log('编辑器 config: ' + config());

        let token = this.$store.state.user.token;
        console.log('token: ' + token);

        console.log('route params, docId:' + this.$route.params.docId);
        console.log('route params, collectedId:' + this.$route.params.collectedId);
        console.log('route params, parentDocId:' + this.$route.params.parentDocId);
        console.log('route params, copyDocId:' + this.$route.params.copyDocId);

        let docId = this.$route.params.docId;
        let collectedId = this.$route.params.collectedId;
        this.parentDocId = this.$route.params.parentDocId;
        this.copyDocId = this.$route.params.copyDocId;

        // 如果附文档参数为_blank，则视为无父级的文档，直属文集，需要清空_blank
        if (this.parentDocId == '_blank') this.parentDocId = '';
        console.log('this.parentDocId:' + this.parentDocId);

        console.log('collectedId:' + collectedId + ' docId:' + docId);

        // 如果附文档ID存在，则查询文档层级路径
        if (this.parentDocId != '') {
            request({
                url: '/doc/getPath',
                method: 'post',
                data: {
                    parentDocId: this.parentDocId
                }
            }).then(res => {
                if (res.code == 0 && res.meta.path) {
                    console.log('层级路径为：' + res.meta.path);
                    this.parentDocPath = res.meta.path;
                }
            });
        }

        // 查询文集信息
        request({
            url: '/collected/get',
            method: 'post',
            data: {
                id: this.$route.params.collectedId
            }
        }).then(res => {
            // 标记当前页面为活动状态
            this.loadStatus = 'active';
            this.collected = res.meta.collected;
            this.uploadSet.uploadDataParams.collectedId = this.collected.id;

            switch (docId) {
                case '_create':
                    this.mode = 'create';
                    break;
                default:
                    request({
                        url: '/doc/getForEdit',
                        method: 'post',
                        data: {
                            id: docId
                        }
                    }).then(res => {
                        if (res.code == 0 && res.meta.doc) {
                            this.content = res.meta.doc.content;
                            this.title = res.meta.doc.title;
                            this.docId = res.meta.doc.id;

                            switch (res.status) {
                                case 'ok': {
                                    if (res.meta.doc.isCurrentUserLock) {
                                        console.log('当前用户获取锁，准许编辑');
                                        document.title = this.title;
                                        this.heartbeatTimer = setInterval(this.heartbeat, 60 * 1000);
                                    } else {
                                        console.log('文档已被其他成员锁定，不能编辑');

                                        let msg = '文档已被其他成员锁定，不能编辑，您可以联系：' + res.meta.user.realName + ' ' + res.meta.user.email + ' ' + '，解除锁定。';
                                        this.$alert(msg, {
                                            confirmButtonText: '关闭',
                                            callback: action => {
                                                window.close();
                                            }
                                        });
                                    }
                                    break;
                                }
                                case 'lock': {
                                    if (res.meta.doc.isCurrentUserLock) {
                                        console.log('当前用户获取锁，准许编辑');
                                        document.title = this.title;
                                        this.heartbeatTimer = setInterval(this.heartbeat, 60 * 1000);
                                    } else {
                                        console.log('文档已被其他成员锁定，不能编辑');
                                        this.lockUser = res.meta.user;

                                        let msg = '文档已被其他成员锁定，不能编辑，您可以联系：' + res.meta.user.realName + ' ' + res.meta.user.email + ' ' + '，解除锁定。';
                                        this.$alert(msg, {
                                            confirmButtonText: '关闭',
                                            callback: action => {
                                                window.close();
                                            }
                                        });
                                    }
                                    break;
                                }
                                case 'unauth': {
                                    this.operationStatus = false;
                                    this.$alert('没有操作权限', {
                                        confirmButtonText: '关闭',
                                        callback: action => {
                                            window.close();
                                        }
                                    });
                                    break;
                                }
                            }
                        }
                    });
                    break;
            }
        });

        // 复制文档
        if (this.copyDocId != '_none') {
            request({
                url: '/doc/get',
                method: 'post',
                data: {
                    id: this.copyDocId
                }
            }).then(res => {
                if (res.code == 0) {
                    this.content = res.meta.doc.content;
                }
            });
        }
    },
    components: { DocFileUpload },
    methods: {
        heartbeat() {
            return request({
                url: '/openapi/heartbeat/lockDoc',
                method: 'post',
                data: {
                    id: this.docId
                }
            }).then(res => {
                if (res.code == 0) {
                    console.log(res);
                }
            });
        },
        // 上传图片
        handleUploadImage(event, insertImage, files) {
            // debugger;
            // 拿到 files 之后上传到文件服务器，然后向编辑框中插入对应的内容
            console.log(files);

            let data = new FormData();
            for (let i = 0; i < files.length; i++) {
                data.append('file', files[i], files[i].name);
            }
            data.append('collectedId', this.collected.id);
            data.append('docId', this.docId);
            data.append('bucketName', '.hidoc');
            return request({
                url: '/f/u',
                method: 'post',
                data
            }).then(res => {
                if (res.code == 0) {
                    insertImage({
                        url: config().hdImageFlag + res.data[0].uname,
                        desc: '图片'
                        // width: 'auto',
                        // height: 'auto',
                    });
                }
            });
        },
        uploadCallback(files) {
            debugger;
            if (files) {
                for (let i = 0; i < files.length; i++) {
                    // 根据文件名，获取文件后缀
                    const fileName = files[i].fileName;
                    const uname = files[i].uname;
                    const id = files[i].id;
                    const fileSuffix = fileName.substring(fileName.lastIndexOf('.') + 1);

                    // 根据不同后缀的文件类型，扩展不同的显示方式
                    switch (fileSuffix) {
                        case 'mp4':
                            {
                                this.$refs.editor.insert(selected => {
                                    const prefix = '<video width="600" controls="controls" src="#hd.uname://';
                                    const suffix = '"></video>';
                                    const content = selected || uname;

                                    return {
                                        // 要插入的文本
                                        text: `${prefix}${content}${suffix}`
                                    };
                                });
                            }
                            break;
                        case 'doc':
                        case 'docx':
                        case 'xls':
                        case 'xlsx':
                        case 'ppt':
                        case 'pptx':
                        case 'pdf':
                        case 'txt':
                        case 'zip':
                        case 'rar':
                        case '7z':
                        default:
                            {
                                this.$refs.editor.insert(selected => {
                                    const prefix = `<div data-hd-file="${id}">`;
                                    const suffix = `</div>`;
                                    const content = selected || fileName;

                                    return {
                                        // 要插入的文本
                                        text: `${prefix}${content}${suffix}`
                                    };
                                });
                            }
                            break;
                    }
                }
            }
        },
        // 打开上传文件窗口
        openUploadFileDialog(fileType) {
            this.uploadSet.dialogVisible = true;
            this.uploadSet.uploadDataParams.fileType = fileType;
            this.$refs['docFileUpload'].openPanel();
        },
        // handleClose(tag) {
        //     this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
        // },
        // showInput() {
        //     this.inputVisible = true;
        //     this.$nextTick(_ => {
        //         this.$refs.saveTagInput.$refs.input.focus();
        //     });
        // },
        // handleInputConfirm() {
        //     let inputValue = this.inputValue;
        //     if (inputValue) {
        //         this.dynamicTags.push(inputValue);
        //     }
        //     this.inputVisible = false;
        //     this.inputValue = '';
        // },
        beforePreviewChange(text, next) {
            // 预览前对文本进行处理，然后再渲染预览
            if (this.loadStatus == 'active') {
                next(mdFormat(text));
            } else {
                next(text);
            }
        },
        textChange(text, html) {
            console.log(this.loadStatus);
            if (this.loadStatus == 'active') {
                this.$refs.editor;
                this.$refs.editor.codemirrorInstance;
            }
        },
        // 保存文档
        save() {
            return request({
                url: '/doc/save',
                method: 'post',
                data: {
                    collectedId: this.collected.id,
                    title: this.title,
                    content: this.content,
                    tag: 'tag',
                    mode: this.mode,
                    id: this.docId,
                    parentDocId: this.parentDocId,
                    unlock: false
                }
            }).then(res => {
                if (res.code == 0) {
                    ElMessage({
                        message: '保存成功',
                        type: 'success',
                        duration: 5 * 1000
                    });
                    uiRefresh('editor', 'doc', this.docId);
                }
            });
        },
        saveAndClose() {
            return request({
                url: '/doc/save',
                method: 'post',
                data: {
                    collectedId: this.collected.id,
                    title: this.title,
                    content: this.content,
                    tag: 'tag',
                    mode: this.mode,
                    id: this.docId,
                    parentDocId: this.parentDocId,
                    unlock: true
                }
            }).then(res => {
                if (res.code == 0) {
                    uiRefresh('editor', 'doc', this.docId);
                    window.isCloseHint = false;
                    window.close();
                }
            });
        },
        // 解锁并关闭编辑器
        close() {
            ElMessageBox.confirm('关闭会丢失您修改的内容，确认继续吗？', '注意', {
                confirmButtonText: '强制关闭页面',
                cancelButtonText: '继续编辑',
                type: 'warning'
            })
                .then(() => {
                    // 关闭编辑器的浏览器界面
                    if (this.mode == 'create') {
                        console.log('创建时关闭，无需解锁');
                        window.isCloseHint = false;
                        window.close();
                    } else {
                        return request({
                            url: '/doc/unlock',
                            method: 'post',
                            data: {
                                id: this.docId
                            }
                        }).then(res => {
                            if (res.code == 0) {
                                window.isCloseHint = false;
                                window.close();
                            } else {
                                ElMessage({
                                    message: res.msg || 'Error',
                                    type: 'error',
                                    duration: 5 * 1000
                                });
                            }
                        });
                    }
                })
                .catch(() => {
                    console.log('继续编辑');
                    // ElMessage({
                    //     type: 'info',
                    //     message: '继续编辑'
                    // });
                });
        },
        openIlinkDialog() {
            // this.ilinkDialog.searchText = '';
            this.ilinkDialog.show = true;
            this.searchIlink();
        },
        searchIlinkEnter(e) {
            if (e.keyCode == 13) {
                this.searchIlink();
            }
        },
        searchIlink() {
            request({
                url: '/collected/preview',
                method: 'post',
                data: { mode: this.ilinkDialog.searchMode, keyword: this.ilinkDialog.searchText, from: 'editor' }
            }).then(res => {
                if (res.code == 0) {
                    this.ilinkDialog.collectedList = res.data;
                }
            });
        },
        addIlinkDoc(docTitle, collectedId, docId) {
            this.$refs.editor.insert(selected => {
                // [🧰 工具软件-数据库工具：DBeaver](#hd.ilink->121981462344892416/121983064824872960)

                const prefix = '[';
                const suffix = '](' + config().hdIlinkFlag + collectedId + '/' + docId + ')';
                const content = selected || docTitle;

                return {
                    // 要插入的文本
                    text: `${prefix}${content}${suffix}`,
                    // 插入后要选中的文本
                    selected: content
                };
            });
            this.ilinkDialog.show = false;
        },
        openTempletDialog() {
            // this.templetDialog.searchText = '';
            this.templetDialog.show = true;
            this.searchTemplet();
        },
        searchTempletEnter(e) {
            if (e.keyCode == 13) {
                this.searchTemplet();
            }
        },
        searchTemplet() {
            request({
                url: '/collected/preview',
                method: 'post',
                data: { mode: this.templetDialog.searchMode, keyword: this.templetDialog.searchText, from: 'editor', isTemplet: true }
            }).then(res => {
                if (res.code == 0) {
                    this.templetDialog.collectedList = res.data;
                }
            });
        },
        addTempletDoc(docTitle, collectedId, docId) {
            request({
                url: '/doc/get',
                method: 'post',
                data: { id: docId }
            }).then(res => {
                if (res.code == 0) {
                    this.doc = res.meta.doc;
                    this.content = this.doc.content;
                    this.templetDialog.show = false;
                }
            });
        },
        formatContent(type) {
            // switch (type) {
            //     case 'chapterNumber':
            //         {
            //             let contentArray = _.split(this.content, '\n');
            //             console.log(contentArray);
            //             let inCodeBlock = false;
            //             _(contentArray).forEach(function (value) {
            //                 if(value.startsWith('```')) includes = true;
            //                 console.log(value);
            //             });
            //         }
            //         break;
            //     case '':
            //     default:
            //         break;
            // }
        }
    }
};
</script>

<style>
/* ===== 顶部操作栏 ===== */
.doc-editor__header {
    height: auto;
    padding: 12px 16px 0;
    text-align: left;
}

.doc-toolbar {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    row-gap: 10px;
    padding: 10px 16px;
    background: linear-gradient(180deg, #ffffff 0%, #fafbfd 100%);
    border: 1px solid #ebeef5;
    border-radius: 12px;
    box-shadow: 0 10px 28px -22px rgba(31, 45, 61, 0.55);
}

/* 次级工具行：与主行保持同一卡片观感，仅用虚线分隔 */
.doc-toolbar--tools {
    margin-top: 8px;
    border-style: dashed;
    background: linear-gradient(180deg, #ffffff 0%, #fbfcfe 100%);
    box-shadow: none;
}

.doc-toolbar__info {
    display: flex;
    flex: none;
    align-items: center;
    min-width: 0;
}

.doc-toolbar__icon {
    display: flex;
    flex: none;
    align-items: center;
    justify-content: center;
    width: 34px;
    height: 34px;
    margin-right: 10px;
    border-radius: 10px;
    font-size: 18px;
    color: #fff;
    background: linear-gradient(135deg, #79bbff 0%, #337ecc 100%);
    box-shadow: 0 8px 16px -10px rgba(51, 126, 204, 0.9);
}

.doc-toolbar__meta {
    display: flex;
    flex-direction: column;
    min-width: 0;
}

.doc-toolbar__title {
    font-size: 14px;
    font-weight: 600;
    line-height: 20px;
    color: #303133;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.doc-toolbar__subtitle {
    font-size: 12px;
    line-height: 16px;
    color: #a8abb2;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

/* 中间标题输入框 */
.doc-toolbar__field {
    flex: 1;
    min-width: 220px;
    max-width: 460px;
    margin: 0 16px;
}

.doc-toolbar__field .doc-title-input .el-input__wrapper {
    height: 34px;
    border-radius: 9px;
    background-color: #fff;
    box-shadow: 0 0 0 1px #e4e7ed inset;
    transition: all 0.2s ease;
}

.doc-toolbar__field .doc-title-input .el-input__wrapper:hover {
    box-shadow: 0 0 0 1px #a0cfff inset;
}

.doc-toolbar__field .doc-title-input .el-input__wrapper.is-focus {
    box-shadow: 0 0 0 1px #409eff inset, 0 10px 18px -14px rgba(64, 158, 255, 0.9);
}

.doc-toolbar__field .doc-title-input .el-input__inner {
    font-weight: 500;
    color: #303133;
}

.doc-toolbar__actions {
    display: flex;
    flex: none;
    flex-wrap: wrap;
    align-items: center;
    row-gap: 8px;
}

.doc-toolbar__status {
    display: flex;
    flex: none;
    align-items: center;
}

/* 操作分组之间的分隔线 */
.doc-toolbar__split {
    width: 1px;
    height: 18px;
    margin: 0 10px;
    background-color: #e4e7ed;
}

.doc-toolbar__actions .toolbar-btn {
    height: 34px;
    padding: 0 16px;
    border-radius: 9px;
    font-weight: 500;
    transition: all 0.2s ease;
}

.doc-toolbar__actions .toolbar-btn > .el-icon {
    margin-right: 6px;
    font-size: 15px;
}

.doc-toolbar__actions .toolbar-btn + .toolbar-btn {
    margin-left: 8px;
}

/* 次级操作：描边按钮 */
.doc-toolbar__actions .toolbar-btn--ghost {
    color: #606266;
    background-color: #fff;
    border-color: #e4e7ed;
}

.doc-toolbar__actions .toolbar-btn--ghost:hover,
.doc-toolbar__actions .toolbar-btn--ghost:focus {
    color: #409eff;
    background-color: #f2f8ff;
    border-color: #a0cfff;
    transform: translateY(-1px);
    box-shadow: 0 10px 18px -12px rgba(64, 158, 255, 0.9);
}

.doc-toolbar__actions .toolbar-btn--danger:hover,
.doc-toolbar__actions .toolbar-btn--danger:focus {
    color: #f56c6c;
    background-color: #fef0f0;
    border-color: #fab6b6;
    box-shadow: 0 10px 18px -12px rgba(245, 108, 108, 0.9);
}

/* 主操作：渐变实心按钮 */
.doc-toolbar__actions .toolbar-btn--primary {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, #409eff 0%, #1e6fd9 100%);
    box-shadow: 0 10px 20px -12px rgba(30, 111, 217, 1);
}

.doc-toolbar__actions .toolbar-btn--primary:hover,
.doc-toolbar__actions .toolbar-btn--primary:focus {
    color: #fff;
    border-color: transparent;
    background: linear-gradient(135deg, #66b1ff 0%, #2b7ee0 100%);
    transform: translateY(-1px);
    box-shadow: 0 14px 24px -12px rgba(30, 111, 217, 1);
}

.el-tag + .el-tag {
    margin-left: 10px;
}
.button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
}
.input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
}
/* 引用项目特效 */
.import-item {
    cursor: pointer;
    background: transparent;
    border: 0;
    border-radius: 0;
    position: relative;
    color: #636363;
}
.import-item:before {
    transition: all 0 linear;
    content: '';
    width: 0%;
    height: 100%;
    background: #59a1ff46;
    position: absolute;
    top: 0;
    left: 0;
}
.import-item:hover:before {
    background: #59a1ff46;
    width: 100%;
}
</style>
